module.exports = __webpack_public_path__ + "static/media/techCat.0c4849b0.jpg";